<template>
  <div>
    <van-checkbox
      :checked-color="sGetConfig('color2')"
      v-model="s2.Qty"
      @change="onChange()"
      shape="square"
      :disabled="isStopSale(s2.ItemName)"
      class="text-size"
      style="text-align: left"
    >
      <!-- {{ s2 }} -->
      <div style="text-align: left; line-height: 2rem">
        {{ s2.DispName }}

        <span class="C1" v-if="s2.Price1 != 0"> +${{ s2.Price1 }}</span>
        <span v-if="isStopSale(s2.ItemName)"> 售完</span>
      </div>
    </van-checkbox>
    <!-- {{ $store.state.sStopSale }} -->
  </div>
</template>

<style scoped>
.van-checkbox {
  min-height: 3rem;
}
</style>

<script>
export default {
  props: {
    s2: Object,
  },
  methods: {
    onChange() {
      this.$emit("change", this.s2);
    },
    isStopSale(itemname) {
      const find = this.$store.state.sStopSale.find((r) => r.ItemName == itemname);
      return find;
    },
  },
};
</script>
